<!--
   Created by qing on 2020/12/19
   Des: 评论输入框
-->
<template>
  <div class="comment-btn-container">
    <div class="comment-btn">
      <el-input readonly placeholder="发表评论..." @focus="focusComment"></el-input>
    </div>

    <van-popup
      class="comment-input-popup"
      v-model="showCommentInput"
      :style="{ height: '80%', width: '100%' }"
      position="bottom"
      get-container="body"
      @close="inputClose">
      <div class="comment-submit-container" v-if="showCommentInput" id="commentSubmit">

        <div class="comment-content">
          <div class="reply-container" v-if="commentStatus === 'REPLY'">
            <div class="line"></div>
            <div class="reply-content">
              回复&nbsp;&nbsp;{{replyCommentInfo.userName}}:&nbsp;{{fetchSourceContent(replyCommentInfo.commentId)}}
            </div>
          </div>

<!--          <van-field-->
<!--            v-model="commentInfo.content"-->
<!--            :autosize="{ maxHeight: 240, minHeight: 120 }"-->
<!--            type="textarea"-->
<!--            placeholder="请输入评论"-->
<!--          />-->
          <ry-quill-editor
            ref="RyQuillEditor"
            placeholder="请输入评论"
            :content.sync="commentInfo.content">
          </ry-quill-editor>

          <ul class="file__list">
            <li v-for="(file, idx) in commentInfo.attachmentList">
              <div class="file__icon">
                <svg class="icon" aria-hidden="true">
                  <use :xlink:href="actionFileType2FileImage(file.fileType)"></use>
                </svg>
              </div>
              <div class="file__info">
                <div class="file__info-name">
                  {{file.fileName}}
                </div>

                <div class="file__info-bottom">

                  <div class="file__info-size">
                    {{file.fileSize}}KB
                  </div>

                  <div class="file__info-handle">
                    <div
                      class="handle-button"
                      @click.stop.prevent.left="downloadFile(file)">
                      下载
                    </div>
                    <div class="divider"></div>
                    <div
                      class="handle-button"
                      style="color: red"
                      @click.stop.prevent.left="commentInfo.attachmentList.splice(idx, 1)">
                      删除
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div class="handle" :style="{justifyContent: commentStatus === 'EDIT' ? 'flex-end' : 'space-between'}">
          <div v-if="commentStatus !== 'EDIT'">
            <el-checkbox v-model="commentInfo.noticeCharge" :true-label="1" :false-label="0">通知负责人</el-checkbox>
            <el-checkbox v-model="commentInfo.noticePart" :true-label="1" :false-label="0">通知参与人</el-checkbox>
          </div>
          <div>
            <el-button
              type="text"
              icon="el-icon-paperclip"
              @click.stop.prevent.left="selectFile"
            ></el-button>
            <el-button
              size="mini"
              type="success"
              @click.stop.prevent.left="submitComment">
              评论
            </el-button>
          </div>
        </div>
      </div>

    </van-popup>
  </div>
</template>

<script>
  import {accurateFormatDate, fileType2FileImage, getSimpleText, clone} from "../../../assets/js/Untis";
  import {uuid} from "../../RyForm/utils";

  const comment = {
    mixFormId: '',
    nodeId: '',
    itemId: '',
    commentType: '',
    rootId: '',
    replyId: '',
    content: "",
    noticePart: 1,
    noticeCharge: 1,
    attachmentList: []
  }
  export default {
    props: {
      nodeId: {
        type: String,
        default: ''
      },
      itemId: {
        type: String,
        default: ''
      },
      mixFormId: {
        type: String,
        default: ''
      },
      commentType: {
        type: String,
        default: 'NODE' // NODE/ ITEM
      },
      fetchSourceContent: Function
    },
    data() {
      return {
        showCommentInput: false,
        commentStatus: 'NONE', // NONE 首次发表评论、 REPLY 回复评论、 EDIT 编辑评论
        commentInfo: null,
        replyCommentInfo: null,

        downloadEle: null,
        fileInput: null,
        showLoading: false,
      }
    },
    created() {
      this.downloadEle = document.createElement('a')
      this.downloadEle.setAttribute('target', '_blank')

      this.fileInput = document.createElement('input')
      this.fileInput.setAttribute('type', 'file')
      this.fileInput.onchange = this.fileChange
    },
    methods: {
      actionFileType2FileImage(fileType) {
        return fileType2FileImage(fileType)
      },

      open({commentStatus, commentInfo, replyCommentInfo}) {
        this.commentStatus = commentStatus
        this.replyCommentInfo = replyCommentInfo
        if (commentStatus === 'EDIT') {
          this.commentInfo = commentInfo ? clone(commentInfo) : clone(comment)
        }
        if (!this.commentInfo) {
          this.commentInfo = commentInfo ? clone(commentInfo) : clone(comment)
        }
        this.showCommentInput = true
        setTimeout(() => {
          this.$nextTick(() => {
            if (this.$refs.RyQuillEditor) {
              this.$refs.RyQuillEditor.focus()
            }
          })
        },500)

      },
      close() {
        this.showCommentInput = false
      },
      inputClose() {
        if (this.commentStatus === 'EDIT') {
          this.commentInfo = null
        }
      },

      // 首次填写评论
      focusComment() {
        console.log('focusComment')
        this.$emit('focusComment')
      },

      selectFile() {
        this.fileInput.click()
      },

      fileChange(e) {
        const file = e.target.files[0]
        const fileInfo = {
          fileName: file.name,
          fileSize: (file.size / 1000).toFixed(2),
          fileUrl: '',
          fileType: file.type || file.name.split('.').slice(-1)[0],
          id: uuid('FILE')
        }
        this.showLoading = true
        this.$RyFs.upload(e.target.files)
          .then(res => {
            fileInfo.fileUrl = res[0]
            this.commentInfo.attachmentList.push(fileInfo)
          })
          .catch(err => {
            this.$toast.fail('上传失败')
            console.error(err)
          })
          .finally(() => {
            this.fileInput.value = ''
            this.showLoading = false
          })
      },

      // 下载文件
      downloadFile(file) {
        this.downloadEle.setAttribute('download', file.fileName)
        this.downloadEle.setAttribute('href', `${file.fileUrl}?userId=${this.$store.state.userInfo.userId}`)
        this.downloadEle.click()
      },
      // 发表评论
      submitComment() {
        console.log(this.commentInfo)
        if (!this.commentInfo.content && !this.commentInfo.attachmentList.length) {
          this.$toast.fail('评论内容或附件不能为空')
          return
        }
        const loading = this.$toast.loading()
        this.commentInfo.commentType = this.commentType
        if (this.commentStatus === 'EDIT') {
          this.$store.dispatch('actionCommentUpdate', {
            ...this.commentInfo
          }).then(res => {
            this.$emit('submitCommentComplete', {
              commentStatus: this.commentStatus,
              commentInfo: clone(this.commentInfo)
            })
            this.commentInfo = null
            this.$toast.success('更新成功')
            this.showCommentInput = false
          }).catch(console.error)
            .finally(() => {
              loading.clear()
            })

        } else {
          this.commentInfo.mixFormId = this.mixFormId
          this.commentInfo.nodeId = this.nodeId
          this.commentInfo.itemId = this.itemId
          if (this.commentStatus === 'REPLY') {
            this.commentInfo.rootId = this.replyCommentInfo.rootId
            this.commentInfo.replyId = this.replyCommentInfo.commentId
          }
          this.$store.dispatch('actionMixFormCommentAdd', {
            ...this.commentInfo
          }).then(res => {
            this.$emit('submitCommentComplete', {
              commentStatus: this.commentStatus,
              commentInfo: res
            })
            this.commentInfo = null
            this.$toast.success('评论成功')
            this.showCommentInput = false
          }).catch(console.error)
            .finally(() => {
              loading.clear()
            })
        }
      },
    }
  }
</script>

<style lang="less">

  .comment-btn-container {
    background: #f7f7f7;
    width: 100%;
    padding: 12px;
    box-shadow: 0 -2px 5px rgba(0, 0, 0, .1);
    position: absolute;
    bottom: 0;
    left: 0;
    max-height: 480px;
    overflow: auto;

    .comment-btn {
      width: 100%;
      padding-right: 12px;
      overflow-y: auto;
      position: relative;
      border-radius: 2px;
    }
  }

  .comment-input-popup {

    .comment-submit-container {
      position: relative;
      width: 100%;
      height: 100%;

      .comment-content {
        position: absolute;
        top: 0;
        bottom: calc(50px + env(safe-area-inset-bottom));
        left: 0;
        right: 0;
        overflow: auto;

        .van-field {
          border: 1px solid #e6e6e6;
          margin: 10px;
          width: calc(100% - 20px);
        }

        .quill-editor {
          margin: 10px 5px;

          .ql-container {
            min-height: 100px;
            max-height: 300px;

            .ql-editor {
              max-height: 300px;
            }
          }
        }

        .reply-container {
          background-color: #F4F4FA;
          padding: 10px;
          display: flex;
          width: 100%;
          cursor: pointer;

          .line {
            width: 3px;
            height: 14px;
            background-color: #909399;
            margin-right: 10px;
          }

          .reply-content {
            font-size: 13px;
            width: calc(100% - 20px);
            color: #909399;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-wrap: break-word;
          }
        }

        .file__list {
          padding: 0 10px;

          > li {
            width: 100%;
            padding-bottom: 5px;
          }
        }
      }

      .handle {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;
        position: absolute;
        height: 50px;
        bottom: calc(env(safe-area-inset-bottom));
        left: 0;
        right: 0;

        > div {
          display: flex;
          align-items: center;

          .el-button--text {
            i {
              font-size: 20px;
            }
          }

          .el-button--success {
            height: 30px;
            padding: 0 15px;
          }
        }
      }
    }
  }

</style>